import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getFromStorage } from 'src/lib/storage';
import { getAllSpecialtiesListSlice } from 'src/modules/SuperAdmin/store/slices';
import { useDispatch } from 'react-redux';
import { addNewCondition } from 'src/modules/SuperAdmin/store/actions/condition.action';
import { SuperAdminModal } from '../../../baseComponents';
import * as Yup from 'yup';

const AddNewCondition = ({ isOpen, setIsOpen, isfilterOn, filterValue }) => {
  const initialValues = {
    specialty_id: '',
    condition_name: '',
    condition_id: '',
    condition_type: '',
  };

  const validationSchemaField = Yup.object().shape({
    specialty_id: Yup.string().required('Specialty is required'),
    condition_type: Yup.string().required('Condition type is required'),
    condition_name: Yup.string().required('Condition name is required'),
  });

  const dispatch = useDispatch();
  const { appointmentTypeValues } = useSelector(
    (state) => state?.appointmentState
  );
  const { getAllSpecialtiesList } = useSelector(
    (state) => state?.specialtyState
  );
  const cachedUserEmail = getFromStorage(`user_email`);

  const [appointmentTypes, setAppointmentTypes] = useState([]);
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [radioButtonValue, setRadioButtonvalue] = useState(1);
  const [storeSpecialtyId, setStoreSpecialtyId] = useState(null);
  const [storeConditionType, setStoreConditionType] = useState('');

  const condition_type_options = [
    { value: 'generic', label: 'Generic' },
    { value: 'specialized', label: 'Specialized' },
  ];

  useEffect(() => {
    if (getAllSpecialtiesList && Array.isArray(getAllSpecialtiesList)) {
      let dataArr = [];
      getAllSpecialtiesList.forEach((key) => {
        if (key?.specialty_name !== '') {
          dataArr.push({
            value: key?.specialty_id,
            label: key?.specialty_name,
          });
        }
      });
      setSpecialtyOptions(dataArr);
    }
  }, [getAllSpecialtiesList]);

  useEffect(() => {
    if (appointmentTypeValues && Array.isArray(appointmentTypeValues)) {
      const dataArr = appointmentTypeValues.map((item) => ({
        value: item?.appointment_type_id,
        label: item?.appointment_type_text,
      }));
      setAppointmentTypes(dataArr);
    }
  }, [appointmentTypeValues]);

  const handleRadioButton = (e) => {
    const selectedAppointmentTypeId = e.target.value;
    setRadioButtonvalue(selectedAppointmentTypeId);
  };

  const sections = [
    {
      heading: 'Add condition',
      fields: [],
    },
    {
      heading: 'radio_group',
      className: 'grid grid-cols-3 gap-4',
      fields: [
        {
          name: 'condition_name',
          type: 'text',
          title: 'Condition name',
          placeholder: 'Type condition',
        },
        {
          name: 'specialty_id',
          type: 'select',
          title: 'Specialty name',
          placeholder: 'Select specialty',
          options: specialtyOptions,
          onChange: (setFieldValue, e) => {
            setFieldValue('specialty_id', e);
            setStoreSpecialtyId(e);
          },
        },
        {
          name: 'condition_type',
          type: 'select',
          title: 'Condition type',
          placeholder: 'Select condition type',
          options: condition_type_options,
          onChange: (setFieldValue, e) => {
            setFieldValue('condition_type', e);
            setStoreConditionType(e);
          },
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      initialValues={initialValues}
      validationSchema={validationSchemaField}
      className={'feedback-modal'}
      closable={false}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      handleCancel={() => {
        setIsOpen(false);
        dispatch(getAllSpecialtiesListSlice([]));
        setRadioButtonvalue(1);
        setStoreSpecialtyId(null);
      }}
      handleSubmit={(values) => {
        const payload = {
          specialty_id: storeSpecialtyId,
          appointment_type_id: radioButtonValue,
          condition_name: values?.condition_name,
          condition_type: storeConditionType,
          created_by: cachedUserEmail,
        };
        dispatch(
          addNewCondition(
            payload,
            setIsOpen,
            setRadioButtonvalue,
            isfilterOn,
            filterValue
          )
        );
      }}
      appointmentTypes={appointmentTypes}
      handleRadioButton={handleRadioButton}
      radioButtonValue={radioButtonValue}
    />
  );
};

export default AddNewCondition;
